<template>
    <Field :name="name" v-slot="{ field, errors }" v-bind="fieldValidateOn">
        <Radio
            v-model="field.value"
            @update:modelValue="field['onUpdate:modelValue']"
            @change="field.onChange"
            @blur="field.onBlur"
            :errorMessages="errors"
            :field-error="!isEmpty(errors)"
            v-bind="input" />
    </Field>
</template>

<script lang="ts">
    import { PropType, ExtractPropTypes, defineComponent, inject } from 'vue';
    import { FieldValidateOn } from '../../Validations/Validations.interfaces';
    import { Field } from 'vee-validate';
    import { isEmpty } from 'lodash';
    import Radio from './Radio.vue';

    type RadioProps = ExtractPropTypes<typeof Radio.props>;

    export default defineComponent({
        name: 'RadioField',
        methods: { isEmpty },
        components: { Field, Radio },
        props: {
            name: {
                type: String,
                required: true,
            },
            input: {
                type: Object as PropType<Partial<RadioProps>>,
                default: () => ({}),
            },
        },
        setup() {
            const fieldValidateOn = inject('fieldValidateOn') as FieldValidateOn;

            return { fieldValidateOn };
        },
    });
</script>
